
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"9.38","height":"7.779","viewBox":"0 0 9.38 7.779"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"elektramat-triangle","d":"M402.96 467.874l4.967 3.079-4.967 3.079v-6.158m-.586-1.611a.557.557 0 00-.556.556v8.27a.555.555 0 00.556.554.547.547 0 00.291-.084l6.67-4.134a.554.554 0 000-.943l-6.67-4.136a.561.561 0 00-.291-.084z","transform":"rotate(90 438.73 36.913)","fill":"#196cae"}})])
          )
        }
      }
    